import { Alert, Checkbox, FormStack } from "@marekl/adminer/components";
import { ROLE_LABELS, ROLE_OPTIONS } from "./memberFormSchema";
import { MailLink } from "../../../components/SupportContacts";
import { GENERAL_CONTACT } from "../../../lib/contacts";
import type { MembershipRole } from "../../../lib/queries/memberships";

/**
 * RoleCheckboxes is the „Role v týmu" block, shared by every dialog that sets
 * a membership's roles (MemberFormFields, the registry's AddToTeamModal), so
 * the leader's rules live in one place: pass LEADER_ROLE_OPTIONS and
 * `showLeaderNote` for the team's current leader, who may not be Asistent
 * and may hold no role at all („pouze vedoucí").
 */
export function RoleCheckboxes({
  value,
  onChange,
  options = ROLE_OPTIONS,
  showLeaderNote = false,
  disabled = false,
  error,
}: {
  value: MembershipRole[];
  onChange: (next: MembershipRole[]) => void;
  options?: MembershipRole[];
  showLeaderNote?: boolean;
  disabled?: boolean;
  error?: string;
}) {
  return (
    <FormStack>
      <strong style={{ fontSize: 13 }}>Role v týmu</strong>
      {showLeaderNote && (
        <div>
          <Checkbox label="Vedoucí" checked disabled onChange={() => {}} />
          <p style={{ margin: "2px 0 4px 24px", fontSize: 12, color: "var(--adminer-color-ink-dim)" }}>
            Roli vedoucího může změnit pouze administrátor ČNSMS. V případě potřeby kontaktujte ČNSMS na <MailLink to={GENERAL_CONTACT} />.
          </p>
        </div>
      )}
      {options.map((role) => (
        <Checkbox
          key={role}
          label={ROLE_LABELS[role]}
          checked={value.includes(role)}
          disabled={disabled}
          onChange={(e) =>
            onChange(e.target.checked ? [...value, role] : value.filter((r) => r !== role))
          }
        />
      ))}
      {error && <Alert variant="err">{error}</Alert>}
    </FormStack>
  );
}
